import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';

import { TextBlock, Stack, PlaceholderText } from 'sarsaparilla';

import NeedToKnowListItem from './NeedToKnowListItem';

export default function NeedToKnowList({
    listItems = [],
    className,
    headingLevel = 3,
    isLoading,
    space = 'lg',
    ...rest
}) {
    if (isLoading) {
        return (
            <Stack space="lg">
                <PlaceholderText lines={2} />
                <PlaceholderText lines={2} />
            </Stack>
        );
    }

    if (isEmpty(listItems)) {
        return null;
    }

    return (
        <div
            data-component="NeedToKnowList"
            className={cx('shared-need-to-know-list', className)}
            {...rest}
        >
            <TextBlock>
                <Stack hasListRole space={space}>
                    {listItems.map((item, index) => (
                        <NeedToKnowListItem
                            key={index}
                            headingLevel={headingLevel}
                            {...item}
                        />
                    ))}
                </Stack>
            </TextBlock>
        </div>
    );
}

NeedToKnowList.propTypes = {
    listItems: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            priority: PropTypes.string,
            description: PropTypes.node,
        })
    ),
    className: PropTypes.string,
    headingLevel: PropTypes.number,
    isLoading: PropTypes.bool,
    space: PropTypes.string,
};
